const DC_Constants = Object.freeze({
    BABY_SHOWER : 'Baby Shower Tea Party',
    TRIP_EVENT : 'Trip',
    DEFAULT_EVENT : 'Select the type of event'
});

export default DC_Constants;